module.exports = __webpack_public_path__ + "static/media/primary.736f00f6.svg";